import store from '../store'

export default function militaryAndLanguage() {
    const defaultLang = store.state.user.segment.default_lang
    const localStorageLang = localStorage.getItem('bookingLang')
    if (store.state.user.segment.military_time) return true
    if (localStorageLang) {
        if (!store.state.user.segment.military_time && (localStorageLang !== 'en')) {
          return true
        }
        if (!store.state.user.segment.military_time && (localStorageLang === 'en')) {
          return false
        }
    }
    if (!store.state.user.segment.military_time && (defaultLang !== 'en')) {
        return true
    }
    if (!store.state.user.segment.military_time && (defaultLang === 'en')) {
        return false
    }
}